import { newOfficer } from "../Officer/officer";
import { convertToIsoDateTime } from "../datetime";
import LoginAction from "@common/redux/actions/LoginAction";
import OfficerAction from "@common/redux/actions/OfficerAction";

export const suspiciousActivityCreatePayload = (data, linkedAlertData) => {
  const { siteGuid } = LoginAction.data();
  const { policeId } = OfficerAction.data();

  const officerId = data.officer && data.officer.id ? data.officer.id : null;
  const officer =
    data.officer && !data.officer.id
      ? newOfficer(data.officer, policeId)
      : null;

  const customers =
    data.customerIds && data.customerIds.length > 0
      ? data.customers.filter(
          (customer) => !data.customerIds.includes(customer.id),
        )
      : data.customers;

  return {
    ...data,
    incidentDate: convertToIsoDateTime(data.date, data.time),
    incidentStatus: {
      id: 2,
      name: "In Review",
    },
    incidentType: {
      id: 3,
      name: "Suspicious Activity",
    },
    site: { guid: siteGuid },
    customerIncident: null,
    enforcementVisit: null,
    gamblingDispute: null,
    suspiciousActivity: {
      ...data,
      suspiciousActivityDetails: data.description,
      capturedByCctv: data.cctvCatched,
      policeContactedDateTime: convertToIsoDateTime(
        data.date,
        data.timeServicesContacted,
      ),
      policeArrivedDateTime: convertToIsoDateTime(
        data.date,
        data.timeServicesArrived,
      ),
      policeDidNotAttend: data.servicesDidNotAttend,
      officerId: officerId,
      officer: officer,
      suspiciousActivityType: {
        id: data.activityType,
        name: "",
      },
      customers: customers,
    },
    alertIds: linkedAlertData.map((x) => x.id),
  };
};
